package io.horion.auth.api.services

import io.horion.auth.api.models.Endpoint
import io.horion.auth.api.models.domain.profile.User
import io.horion.auth.api.models.domain.profile.UserRequest
import io.horion.auth.api.models.response.Response
import io.horion.auth.api.utils.ApiClient.client
import io.horion.auth.api.utils.Constants.API_AUTH_URL
import io.horion.auth.api.utils.Constants.API_PROFILE_URL
import io.ktor.client.request.accept
import io.ktor.client.request.get
import io.ktor.client.request.headers
import io.ktor.client.request.post
import io.ktor.client.request.put
import io.ktor.client.request.setBody
import io.ktor.client.statement.bodyAsText
import io.ktor.http.ContentType
import io.ktor.http.HttpStatusCode
import io.ktor.http.contentType
import kotlinx.serialization.json.Json

class ProfileService {

    suspend fun saveUser(profile : UserRequest) : Response {
        return try {
            val response = client.post("$API_PROFILE_URL${Endpoint.UserCreate.path}") {
                contentType(ContentType.Application.Json)
                accept(ContentType.Application.Json)
                setBody(profile)
            }

            val responseText = response.bodyAsText()
            val res = Json.decodeFromString<Response>(responseText)
            res
        } catch (e: Exception) {
            Response(false,"Erreur de connexion")
        }
    }

    suspend fun updateUser(profile: UserRequest) : Response {
        return try {
            val response = client.put("$API_PROFILE_URL${Endpoint.UserUpdate.path}") {
                contentType(ContentType.Application.Json)
                accept(ContentType.Application.Json)
                setBody(profile)
            }

            val responseText = response.bodyAsText()
            val res = Json.decodeFromString<Response>(responseText)
            res
        } catch (e: Exception) {
            Response(false,"Erreur de connexion")
        }
    }

    suspend fun readUser() : User? {
        return try {
            val response = client.get("$API_PROFILE_URL${Endpoint.UserRead.path}") {
                contentType(ContentType.Application.Json)
                accept(ContentType.Application.Json)
            }

            val responseText = response.bodyAsText()
            val res = Json.decodeFromString<User>(responseText)
            res
        } catch (e: Exception) {
            null
        }
    }

}